module.exports = __webpack_public_path__ + "static/media/company_logo.b4969b15.png";